/* eslint-disable no-console */
import axios from 'axios';

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const instance = axios.create({
    baseURL: window.api,
    timeout: 5000,
    // headers: { "Access-Control-Allow-Origin": "*" },
    // withCredentials: false
});

export default {
    getLogo() {
        return instance.get('/logo', {}).then(data => data.data)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getBanners() {
        return instance.get('/banner', {})
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getCommonAsset() {
        return instance.get('/common_asset', {})
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getBodyAsset() {
        return instance.get('/body_asset', {})
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getCompanyName() {
        return instance.get('/name', {}).then(data => data.data)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getMinDeposit() {
        return instance.get('/min_deposit', {}).then(data => data.data)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getMinWithdraw() {
        return instance.get('/min_withdraw', {}).then(data => data.data)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getMinTransfer() {
        return instance.get('/min_transfer', {}).then(data => data.data)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postLogin(obj) {
        return instance.post('/login', {
            'username': obj.username,
            'password': obj.password,
            'token': obj.token,
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postRegister(obj) {
        return instance.post('/register', {
            'username': obj.username,
            'password': obj.password,
            'password_confirmation': obj.password_confirmation,
            'fullname': obj.fullname,
            'tel_no': obj.tel_no,
            'token': obj.token
        }).then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postChangePassword(obj) {
        return instance.post('/change_password', {
            'old_password': obj.old_password,
            'password': obj.password,
            'password_confirmation': obj.password_confirmation,
            'access_token': obj.access_token
        }).then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getPromotions() {
        return instance.get('/promotion', {})
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getContact() {
        return instance.get('/contact')
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getLivechat() {
        return instance.get('/livechat').then(data => data.data)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getPage(obj) {
        return instance.get('/page', {
            params: {
                'name': obj.name
            }
        }).then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getProducts() {
        return instance.get('/product', {})
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getProductsMember(obj) {
        return instance.get('/product/member', {
            params: {
                'access_token': obj.access_token
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getBankAccounts(obj) {
        return instance.get('/bank_account', {
            params: {
                'access_token': obj.access_token
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getMemberPromotions(obj) {
        return instance.get('/promotion/member', {
            params: {
                'access_token': obj.access_token,
                'productTo': obj.productTo
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getMemberInfo(obj) {
        return instance.get('/member', {
            params: {
                'access_token': obj.access_token
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postBankAccount(obj) {
        return instance.post('/member/bank_account', obj)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getBanks(obj) {
        return instance.get('/bank', {
            params: {
                'access_token': obj.access_token
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postDeposit(obj) {
        return instance.post('/tickets/deposit', obj,
        {
            headers:
            {
                'Content-Type' : 'multipart/form-data'
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postWithdraw(obj) {
        return instance.post('/tickets/withdraw', obj)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postTransfer(obj) {
        return instance.post('/tickets/transfer', obj)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postBonus(obj) {
        return instance.post('/tickets/bonus', obj)
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getTicketHistory(obj) {
        return instance.get('/tickets', {
            params: obj
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getNotification(obj) {
        return instance.get('/member/get_Notification', {
            params: {
                'access_token': obj.access_token
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    updateNotification(obj) {
        return instance.post('/member/update_Notification', {
            'access_token': obj.access_token
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postFcmTokenForVisitor(obj) {
        return instance.post('/fcm/saveToken', {
            'token' : obj.token,
            'frontend_url' : obj.frontend_url,
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    postFcmTokenForUser(obj) {
        return instance.post('/fcm/storeToken', {
            'access_token': obj.access_token,
            'frontend_url' : obj.frontend_url,
            'token' : obj.token
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    deleteFcmTokenForVisitor(obj) {
        return instance.post('/fcm/deleteToken', {
            'token' : obj.token,
            'frontend_url' : obj.frontend_url,
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    deleteFcmTokenForUser(obj) {
        return instance.post('/fcm/removeToken', {
            'access_token': obj.access_token,
            'frontend_url' : obj.frontend_url,
            'token' : obj.token
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getFCMConfig() {
        return instance.get('/fcm_config', {})
            .then(data => data.data)
            .catch(error => this.returnError(error))
    },

    getCurrency() {
        return instance.get('/currency')
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getAvailableServices() {
        return instance.get('/available_services')
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    getMemberMiniGameUrl(obj) {
        return instance.get('/mini_game',
            {
                params: {
                    'access_token': obj.access_token,
                }
            }
        )
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },
    getMemberMiniGameProfile(obj) {
        return instance.get('/member/mini_game/profile', {
            params: {
                'access_token': obj.access_token
            }
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },
    getMemberMiniGamePrizesList(obj) {
        return instance.get('/member/mini_game/prizesList', {
            params: obj
        })
        .then(data => data.data)
        .catch(error => this.returnError(error))
    },

    returnError(error) {
        let value = {};
        try {
            value = error.response.data
        } catch(e) {
            value = {'success': false, 'message': 'Network error'};
        }
        return value;
    }
}